import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from '../../utils/utils';
import intl from 'react-intl-universal';
import { getFeatureListByProductId } from './features';
import { publishProduct } from './product';

message.config({
  top: 300,
  maxCount: 3
});

// 更新功能点编辑
export const UPDATE_FEATUREEDIT_DATA = "UPDATE_FEATUREEDIT_DATA";
// 设置弹窗状态
export const SET_FEATUREEDITMODALVISIBLE = "SET_FEATUREEDITMODALVISIBLE";
// 设置操作类型
export const SET_OPERATETYPE = "SET_OPERATETYPE";
// 设置loading状态
export const SET_CONFIRMLOADING = "SET_CONFIRMLOADING";
// 编辑已添加功能点情况，保存 id 和 sourceTrabsType
export const SET_SOURCETRABSTYPE = "SET_SOURCETRABSTYPE";



// 新增自定义功能点
export function addNewFeatureEdit() {
  return (dispatch, getState) => {
    dispatch(resetFeatureEditData());
    dispatch(setOperateType('add'));
    dispatch(setFeatureEditModalVisible(true));
  }
}

// 编辑已添加的功能点
export function startFeatureEdit(originValue) {
  return (dispatch, getState) => {
    const value = JSON.parse(JSON.stringify(originValue))
    const data = value;
    //判断是否是事件，如果是取事件的deInput
    const isEvent = value.deInput
      && value.deInput.properties
      && value.deInput.properties.payload
      && value.deInput.properties.payload.properties
      && value.deInput.properties.payload.properties.value
    data.deInput = isEvent ? value.deInput.properties.payload.properties.value : value.deInput;
    // 名称增加中英文
    data.deName = { zh: value.deNameCh, en: value.deNameEn };

    dispatch(updateFeatureEditData(data));
    dispatch(updateSourceTrabsType({
      id: value.id,
      sourceTrabsType: value.featureType,
    }))
    dispatch(setOperateType('edit'));
    dispatch(setFeatureEditModalVisible(true));
  }
}


// 重置功能点编辑
export function resetFeatureEditData() {
  return (dispatch, getState) => {
    const newData = {
      featureType: "1",
      // 功能名称	
      deName: '',
      //功能名称中文
      deNameCh: '',
      //功能名称英文
      deNameEn: '',
      //自定义
      isTemplate: 0,
      // 识别符
      deKey: '',
      // 是否可选	 0 必选 1 可选
      deOptional: 1,
      // 功能备注	
      deRemark: '',
      // 传输类型	 1-只上报；2-只下发；3-上报下发；4-操作
      transType: 1,
      // deInput
      deInput: {
        // 数据类型	string，json，boolean，enum，integer
        type: 'boolean',
        // 最大长度
        maxLength: '',
        // 枚举类型
        enumType: 'integer',
        // 枚举值	
        enumValue: [],
        // 最小值	
        minimum: '',
        // 最大值	
        maximum: '',
        // 倍数	
        multipleOf: '',
        // 间隔
        step: '',
        minItems: '',
        maxItems: '',
        properties: {},
        items: {}
      },
      deOutput: {
        // 数据类型	string，json，boolean，enum，integer
        type: 'boolean',
        // 最大长度
        maxLength: '',
        // 枚举类型
        enumType: 'integer',
        // 枚举值	
        enumValue: [],
        // 最小值	
        minimum: '',
        // 最大值	
        maximum: '',
        // 倍数	
        multipleOf: '',
        // 间隔
        step: '',
        minItems: '',
        maxItems: '',
        properties: {},
        items: {}
      },
    }
    const newDeName = { zh: newData.deNameCh, en: newData.deNameEn }
    const lastData = { ...newData, deName: JSON.stringify(newDeName) }
    dispatch({
      type: UPDATE_FEATUREEDIT_DATA,
      featureEditData: lastData,
    });
  };
}
// 更新功能点编辑
export function updateFeatureEditData(data) {
  return (dispatch, getState) => {
    const { featureEditData } = getState().featureEdit;
    const newData = Object.assign({}, featureEditData, data);
    const newDeName = { zh: newData.deNameCh, en: newData.deNameEn }
    const lastData = { ...newData, deName: JSON.stringify(newDeName) }
    dispatch({
      type: UPDATE_FEATUREEDIT_DATA,
      featureEditData: lastData,
    });
  };
}

// 更新 sourceTrabsType
export function updateSourceTrabsType(data) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_SOURCETRABSTYPE,
      sourceTrabsType: data.sourceTrabsType,
      id: data.id,
    });
  };
}

// 设置弹窗状态
export function setFeatureEditModalVisible(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_FEATUREEDITMODALVISIBLE,
      featureEditModalVisible: value,
    });
  };
}

// 设置操作类型
export function setOperateType(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_OPERATETYPE,
      operateType: value,
    });
  };
}

// 设置操作类型
export function setConfirmLoading(value) {
  return (dispatch, getState) => {
    dispatch({
      type: SET_CONFIRMLOADING,
      confirmLoading: value,
    });
  };
}

// 保存功能点配置
export function saveFeatureEditData(params, callback) {
  return (dispatch, getState) => {
    const { operateType, featureEditData, sourceTrabsType, id } = getState().featureEdit;
    const url = operateType === 'add'
      ? '/iot/config/api/iot/support/product/feature/add'
      : '/iot/config/api/iot/support/product/feature/update';
    const body = {
      featureType: featureEditData.featureType,
      deName: featureEditData.deName,
      deKey: featureEditData.deKey,
      deOptional: featureEditData.deOptional,
      deRemark: featureEditData.deRemark,
      transType: featureEditData.transType,
      deInput: featureEditData.deInput,
      deOutput: featureEditData.deOutput,
    };
    if (operateType === 'edit') {
      body.did = featureEditData.did;
    }

    // 如果是事件
    if (featureEditData.featureType == '3') {
      let propertiesAll = {
        type: "json",
        title: "",
        properties: {
          basic: {
            type: "json",
            title: "基础内容",
            properties: {
              dateTime: {
                type: "string",
                title: "事件时间",
                description: "格式为 YYYY-MM-DD'T'HH:mm:ss+zone，例2017-08-01T17:30:08+08:00,或则格式 YYYY-MM-DD'T'HH:mm:ss.fff+zone，（毫秒精度）例2017-08-01T17:30:08.134+08:00设备支持毫秒，优先传毫秒。",
                maxLength: 32,
                minLength: 25
              },
              UUID: {
                type: "string",
                title: "上传事件唯一标识符",
                minLength: 1,
                maxLength: 32
              },
              continue: {
                type: "boolean",
                title: "后续有相同UUID的报文(用于补充图片)",
                default: false,
                const: false,
                description: "默认为false，后续不会有相同UUID的报文。不带图片或则带图片的事件无实时性要求，该节点可以不要。"
              },
              timestamp: {
                type: "number",
                description: "消息时间戳，UTC 1970-01-01 0时开始的毫秒数。行业设备可以不带"
              },
              ipV4Address: {
                type: "string",
                format: "ipv4"
              },
            },
            required: [
              "dateTime",
              "UUID"
            ]
          },
          notification: {
            type: "json",
            description: "提醒消息基础字段，所有告警提醒类消息必须携带",
            properties: {
              status: {
                type: "number",
                title: "事件状态",
                description: "1发生，2停止，该字段目前无实际效果，但予以保留",
                enum: [
                  1,
                  2
                ]
              },
              action: {
                type: "number",
                title: "自定义特殊提醒行为",
                description: "默认为0。目前开放的选项是——：8：不推送"
              },
              location: {
                type: "string",
                title: "设备安装位置",
                description: ""
              },
              relationId: {
                type: "string",
                title: "互联互通消息ID",
                description: "是一个UUID，平台会将多个具有相同relationId的消息关联起来在App上查看。",
                maxLength: 64,
                minLength: 0
              },
              pictures: {
                type: "array",
                title: "",
                items: {
                  type: "object",
                  title: "图片信息",
                  properties: {
                    cloudtype: {
                      type: "integer",
                      description: "云存储类型，根据图片上传信息响应中的同名字段填写 ",
                      title: "存储节点编号，当采用简单存储协议时，为固定值 -1"
                    },
                    bucket: {
                      type: "string",
                      description: "云存储bucket名称，根据图片上传信息响应中的同名字段填写",
                      title: "存储桶信息，采用简单存储协议时，为空"
                    },
                    type: {
                      type: "string",
                      description: "图片格式",
                      title: "文件格式"
                    },
                    length: {
                      type: "integer",
                      description: "图片长度",
                      title: "图片长度",
                      unit: "字节"
                    },
                    crypt: {
                      type: "integer",
                      description: "加密类型：2平台加密，1设备加密，0不加密。注意一条消息中的所有图片必须采用相同的加密方式与加密密钥。",
                      title: "加密类型",
                      enum: [
                        0,
                        1,
                        2
                      ],
                      enumDesc: [
                        "不加密",
                        "设备密钥加密（别称“设备加密”）：密钥是设备本地的验证码，平台不存储，由事件接收方自行根据设备密钥解密",
                        "共享密钥加密（别称“平台加密”）：可以做到每个事件一个密钥， 密钥随业务流程自行传递（多为陪伴事件一起传输），平台服务根据获得的密钥可以转换为解密后的地址。"
                      ]
                    },
                    fileid: {
                      type: "string",
                      description: "存储KEY,根据图片上传信息响应中的同名字段填写",
                      title: "存储KEY"
                    },
                    tinyvideo: {
                      type: "integer",
                      description: "0-没有报警小视频；1-有报警小视频  ",
                      title: "报警小视频",
                      enum: [
                        0,
                        1
                      ],
                      enumDesc: [
                        "没有报警小视频",
                        "有报警小视频"
                      ]
                    },
                    checksum: {
                      type: "string",
                      description: " 对应老协议CapturePicture:CheckSum，如为设备加密，则是设备密钥的checksum，如为平台加密，则为平台加密的密钥部分信息。如没有加密则为空",
                      title: "校验和",
                      minLength: 0,
                      maxLength: 32
                    },
                    lifecycle: {
                      type: "integer",
                      description: " 云图片的存储周期 ，根据图片上传信息响应中的同名字段填写。该字段仅作记录，不会实际影响图片的存储周期。  ",
                      title: "云图片的存储周期",
                      unit: "天"
                    }
                  },
                  required: [
                    "cloudtype",
                    "bucket",
                    "fileid"
                  ]
                }
              }
            },
          },
          payload: {
            type: "json",
            title: "自定义内容",
            properties: {
              value: {
                // type: "boolean",  //这个是自定义的数据类型，根据界面配置生成
                // title: "字段的中文解释，目前交互稿上没有字段这个概念，因此此处固定写‘自定义字段’",
                ...body.deInput
              }
            },
            required: [
              "value"
            ]
          }
        }
      }


      body.deInput = propertiesAll
      body.eventType = ["notification", "general"]

    }
    if (operateType !== 'add') {
      body.sourceFeatureType = sourceTrabsType;
      body.id = id;
    }
    body.productId = params.productId;
    ;
    dispatch(setConfirmLoading(true));
    const fetchData = new FetchData(url, {
      method: "POST",
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(data => {
        dispatch(setConfirmLoading(false));
        if (data.code === '200') {
          if (featureEditData.featureType !== '3' || params.isStandard === 1) {
            dispatch(setFeatureEditModalVisible(false))
          }
          if (featureEditData.featureType == '3' && params.isStandard === 0) {
            callback && callback()
          }
          dispatch(getFeatureListByProductId())
          message.success(intl.get('commmon.operate.success'));
          // 2021-01-05 功能点修改后，调用一次发布接口
          dispatch(publishProduct({ productId: params.productId }))
        } else {
          message.error(data.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        dispatch(setConfirmLoading(false));
        message.error(intl.get('commmon.operate.retry'));
      });
  };
}
